import { Link } from 'react-router-dom'
import CommonModal from '../utils/CommonModal'
import { useEffect, useRef, useState } from 'react'
import { Slider } from '../utils/Slider'
import { CommonTransition } from '../utils/CommonTransition'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBoltLightning, faHelmetSafety, faMapLocationDot, faSolarPanel } from '@fortawesome/free-solid-svg-icons'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { ASSETS_URL } from '../utils/constants'

const bannerResidential = ASSETS_URL + 'banner_residential.jpeg'
const bannerCommercial = ASSETS_URL + 'banner_commercial.jpeg'

//commercial projects
const project2 = ASSETS_URL + 'p_jmc-1.jpg'
const project3 = ASSETS_URL + 'p_kima-1.jpg' 

const aficionado1 = ASSETS_URL + 'project_Aficionado-1.png'
const aficionado2 = ASSETS_URL + 'project_Aficionado-2.png'
const aficionado3 = ASSETS_URL + 'project_Aficionado-3.png'

const adcons1 = ASSETS_URL + 'project_adcons-1.jpeg'
const adcons2 = ASSETS_URL + 'project_adcons-2.jpeg'
const adcons3 = ASSETS_URL + 'project_adcons-3.jpeg'

const liteblock1 = ASSETS_URL + 'project_liteblock-totalSolar-1.webp'
const liteblock2 = ASSETS_URL + 'project_liteblock-totalSolar-2.webp'
const liteblock3 = ASSETS_URL + 'project_liteblock-totalSolar-3.webp'
const liteblock4 = ASSETS_URL + 'project_liteblock-totalSolar-4.webp'
const liteblock5 = ASSETS_URL + 'project_liteblock-totalSolar-5.webp'

//mandauefoam

// const mfCainta1 = ASSETS_URL + 'project_mfCainta-totalSolar-1.jpg'
// const mfCainta2 = ASSETS_URL + 'project_mfCainta-totalSolar-2.jpg'
// const mfCainta3 = ASSETS_URL + 'project_mfCainta-totalSolar-3.jpg'

// const mfDasmarinas1 = ASSETS_URL + 'project_mfDasmarinast-totalSolar-1.png'
// const mfDasmarinas2 = ASSETS_URL + 'project_mfDasmarinast-totalSolar-2.png'
// const mfDasmarinas3 = ASSETS_URL + 'project_mfDasmarinast-totalSolar-3.png'
// const mfDasmarinas4 = ASSETS_URL + 'project_mfDasmarinast-totalSolar-4.png'

// const mfLasPinas1 = ASSETS_URL + 'project_mfLasPinas-totalSolar-1.png'
// const mfLasPinas2 = ASSETS_URL + 'project_mfLasPinas-totalSolar-2.png'
// const mfLasPinas3 = ASSETS_URL + 'project_mfLasPinas-totalSolar-3.png'
// const mfLasPinas4 = ASSETS_URL + 'project_mfLasPinas-totalSolar-4.png'

// const mfMuzon1 = ASSETS_URL + 'project_mfMuzonOld-totalSolar-1.jpeg'
// const mfMuzon2 = ASSETS_URL + 'project_mfMuzonOld-totalSolar-2.jpeg'

// const mfMuzonNew1 = ASSETS_URL + 'project_mfMuzonNew-totalSolar-1.jpg'
// const mfMuzonNew2 = ASSETS_URL + 'project_mfMuzonNew-totalSolar-2.jpg'

// const mfStaRosa1 = ASSETS_URL + 'project_mfStaRosa-totalSolar-1.png'
// const mfStaRosa2 = ASSETS_URL + 'project_mfStaRosa-totalSolar-2.png'
// const mfStaRosa3 = ASSETS_URL + 'project_mfStaRosa-totalSolar-3.png'
// const mfStaRosa4 = ASSETS_URL + 'project_mfStaRosa-totalSolar-4.png'

// const mfShaw1 = ASSETS_URL + 'project_mfShaw-totalSolar-1.jpeg'
// const mfShaw2 = ASSETS_URL + 'project_mfShaw-totalSolar-2.jpeg'
// const mfShaw3 = ASSETS_URL + 'project_mfShaw-totalSolar-3.jpeg'
// const mfShaw4 = ASSETS_URL + 'project_mfShaw-totalSolar-4.jpeg'

//tsuneishi
const grt1 = ASSETS_URL + 'project_tsuneishi-totalSolar-1.jpeg'
const grt2 = ASSETS_URL + 'project_tsuneishi-totalSolar-2.jpeg'
const grt3 = ASSETS_URL + 'project_tsuneishi-totalSolar-3.jpeg'

const decaTondo1 = ASSETS_URL + 'project_decamalltondo-totalSolar-1.jpeg'
const decaTondo2 = ASSETS_URL + 'project_decamalltondo-totalSolar-2.jpeg'
const decaTondo3 = ASSETS_URL + 'project_decamalltondo-totalSolar-3.jpeg'

const metroCentral1 = ASSETS_URL + 'p_totalSolarInstallation_metroCentral-1.jpg'
const metroCentral2 = ASSETS_URL + 'p_totalSolarInstallation_metroCentral-2.jpg'
const metroCentral3 = ASSETS_URL + 'p_totalSolarInstallation_metroCentral-3.jpg'
const metroCentral4 = ASSETS_URL + 'p_totalSolarInstallation_metroCentral-4.jpg'
const metroCentral5 = ASSETS_URL + 'p_totalSolarInstallation_metroCentral-5.jpg'

const kodecPrecInc1 = ASSETS_URL + 'p_totalSolarInstallation_kodecPrecisionInc-1.png'
const kodecPrecInc2 = ASSETS_URL + 'p_totalSolarInstallation_kodecPrecisionInc-2.png'
const kodecPrecInc3 = ASSETS_URL + 'p_totalSolarInstallation_kodecPrecisionInc-3.png'

//sm projects
const smBacolod1 = ASSETS_URL + 'p_totalSolarInstallation_smBacolod-1.png'
const smBacolod2 = ASSETS_URL + 'p_totalSolarInstallation_smBacolod-2.jpg'
const smBacolod3 = ASSETS_URL + 'p_totalSolarInstallation_smBacolod-3.jpg'

const smBataan1 = ASSETS_URL + 'p_totalSolarInstallation_smBataan-1.jpg'
const smBataan2 = ASSETS_URL + 'p_totalSolarInstallation_smBataan-2.png'

const smButuan1 = ASSETS_URL + 'project_smcitybutuan-1.jpg'
const smButuan2 = ASSETS_URL + 'project_smcitybutuan-2.jpg'
const smButuan3 = ASSETS_URL + 'project_smcitybutuan-3.jpg'
const smButuan4 = ASSETS_URL + 'project_smcitybutuan-4.jpg'
const smButuan5 = ASSETS_URL + 'project_smcitybutuan-5.jpg'

const smCebu1 = ASSETS_URL + 'p_totalSolarInstallation_smCebu-1.png'
const smCebu2 = ASSETS_URL + 'p_totalSolarInstallation_smCebu-2.png'
const smCebu3 = ASSETS_URL + 'p_totalSolarInstallation_smCebu-3.jpg'

const smCDOdowntown1 = ASSETS_URL + 'p_totalSolarInstallation_smCDOdowntown-1.jpg'
const smCDOdowntown2 = ASSETS_URL + 'p_totalSolarInstallation_smCDOdowntown-2.jpg'
const smCDOdowntown3 = ASSETS_URL + 'p_totalSolarInstallation_smCDOdowntown-3.jpg'

const smConsolacion1 = ASSETS_URL + 'p_totalSolarInstallation_smConsolacion-1.jpg'
const smConsolacion2 = ASSETS_URL + 'p_totalSolarInstallation_smConsolacion-2.jpg'

const smGenSan1 = ASSETS_URL + 'p_totalSolarInstallation_smGenSan-1.jpg'
const smGenSan2 = ASSETS_URL + 'p_totalSolarInstallation_smGenSan-2.jpg'
const smGenSan3 = ASSETS_URL + 'p_totalSolarInstallation_smGenSan-3.jpg'

const smilo1 = ASSETS_URL + 'project_smcityiloilo-totalSolar-1.JPG'
const smilo2 = ASSETS_URL + 'project_smcityiloilo-totalSolar-2.JPG'
const smilo3 = ASSETS_URL + 'project_smcityiloilo-totalSolar-3.JPG'

const smNova1 = ASSETS_URL + 'p_totalSolarInstallation_smNovaliches-1.png'
const smNova2 = ASSETS_URL + 'p_totalSolarInstallation_smNovaliches-2.png'
const smNova3 = ASSETS_URL + 'p_totalSolarInstallation_smNovaliches-3.png'


//residential projects
const tagaytay1 = ASSETS_URL + 'p_tagaytay-1.jpg'

const skypod1 = ASSETS_URL + 'project_skyPod-1.jpeg'
const skypod2 = ASSETS_URL + 'project_skyPod-2.jpeg'
const skypod3 = ASSETS_URL + 'project_skyPod-3.png'

const uy1 = ASSETS_URL + 'project_beverlyHills-1.jpeg'
const uy2 = ASSETS_URL + 'project_beverlyHills-2.jpeg'
const uy3 = ASSETS_URL + 'project_beverlyHills-3.jpeg'

const almera1 = ASSETS_URL + 'project_almera-1.jpeg'
const almera2 = ASSETS_URL + 'project_almera-2.jpeg'
const almera3 = ASSETS_URL + 'project_almera-3.jpeg'

const manlangit1 = ASSETS_URL + 'project_manlangit-1.jpeg'
const manlangit2 = ASSETS_URL + 'project_manlangit-2.jpeg'
const manlangit3 = ASSETS_URL + 'project_manlangit-3.jpeg'

const sy1 = ASSETS_URL + 'project_sy-1.jpeg'
const sy2 = ASSETS_URL + 'project_sy-2.jpeg'
const sy3 = ASSETS_URL + 'project_sy-3.jpeg'

export function Projects() {
    const containerRef = useRef(null)

    useEffect(() => {
      if(containerRef.current) {
        containerRef.current.parentNode.parentNode.scrollIntoView({ behavior: "smooth", block: "start", inline: "start" })
      }
    }, [containerRef])

    const [isCommercialSelected, setIsCommercialSelected] = useState(false)

    const TypeFilter = ({isCommercial}) => {
        return <div className='w-full h-[175px] sm:h-[250px] relative mt-5 mb-10 flex flex-col'>
            <img alt="'total solar installation','total solar installation by rb gonzales opc','total solar', 'total solar ph', 'total solar philippines', 'solar panel installer', 'solar panel provider', 'solar panel philippines'" src={isCommercial ? bannerCommercial : bannerResidential} className='absolute top-0 left-0 w-full h-[175px] sm:h-[250px] object-cover' />
            <div className='bg-none text-sm font-bold flex w-full ' style={{clipPath: 'inset(0rem -1rem 0rem 0rem)'}}>

                
                <div className={`${isCommercial ? 'bg-[#1E1C1C]': 'bg-[#2ba837]'} hover:bg-[#9aed79] hover:text-[#212121] py-3 px-6 sm:px-10 text-xs sm:text-base cursor-pointer sm:skew-x-[35deg] sm:-ml-4 w-1/2 sm:w-auto`}
                    onClick={() => setIsCommercialSelected(false)}>
                    <div className='sm:-skew-x-[35deg]'>RESIDENTIAL</div>   
                    
                </div>
                

                <div className={`${isCommercial ? 'bg-[#2ba837]': 'bg-[#1E1C1C]'} hover:bg-gray-700 hover:text-[#4CB117] py-3 px-6 sm:px-10 text-xs sm:text-base cursor-pointer sm:skew-x-[35deg] w-1/2 sm:w-auto`}
                    onClick={() => setIsCommercialSelected(true)}>
                    <div className='sm:-skew-x-[35deg]'>COMMERCIAL</div>
                </div>
            </div>
            {
                !isCommercial &&
                <div className='text-[#f7f7f7] text-right text-xs sm:text-base font-bold relative mb-5 mt-auto mx-3 sm:my-auto sm:ml-auto sm:mr-10 sm:w-[50%]'>At Total Solar, we offer a wide range of customizable solar solutions to suit any home, business, and community energy needs. Here are our completed projects throughout the Philippines.</div>
            }
            
        </div>
        
    }

    return <>
    <div ref={containerRef} className="font-[Montserrat] text-[#f7f7f7] w-[80%]">
        
        
        <TypeFilter isCommercial={isCommercialSelected}/>
        
        <div className='w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-8'>
        {
            isCommercialSelected ?
            <CommercialProjects />
            : <ResidentialProjects />
        }
        </div>

        <div className='text-[#f7f7f7] text-center text-m mt-10'>Join us on our mission to create a cleaner, more sustainable future. Discover the power of solar energy with Total Solar Installation!</div>
        <div className='text-[#f7f7f7] text-center text-m mt-2'><Link to={'/contact'} className='hover:underline text-[#4CB117]'>Send us a message for a free quatation!</Link></div>

    </div>
    </>
}

const CommercialProjects = () => {
    const projects = [
        {
            name: 'Kodec Precision Inc. (Industrial)',
            location: 'Bacolor, Pampanga',
            kwp: ' 2008.80 kWp / 1650 kWAC ',
            panels: '3240 panels',
            scope: 'Construction',
            pictures: [kodecPrecInc1,kodecPrecInc2,kodecPrecInc3]
        },
        {
            name: 'SM City Bacolod',
            location: 'Bacolod, Negros Occidental',
            kwp: ' 1.239MWp / 1.0MW AC Solar PV Power Grid Tied System',
            panels: '1982 panels',
            scope: 'EPC and O&M Services',
            pictures: [smBacolod1,smBacolod2,smBacolod3]
        },
        {
            name: 'SM City Bataan',
            location: 'Balanga City, Bataan',
            kwp: ' 2.376MWp / 2.09MW AC Solar PV Power Grid Tied System',
            panels: '4062 panels',
            scope: 'EPC and O&M Services',
            pictures: [smBataan1,smBataan2]
        },
        {
            name: 'SM City Butuan',
            location: 'Butuan City, Agusan Del Norte',
            kwp: '851.4kW DC / 700 kW AC Solar PV Power Grid Tied System',
            panels: '1468 panels',
            scope: 'EPC and O&M Services',
            pictures: [smButuan1,smButuan2,smButuan3,smButuan4,smButuan5]
        },
        {
            name: 'SM City Cebu',
            location: 'Cebu City, Cebu',
            kwp: '2.837MWp / 2.3MW AC Solar PV Power Grid Tied System',
            panels: '4504 panels',
            scope: 'EPC and O&M Services',
            pictures: [smCebu1,smCebu2,smCebu3]
        },
        {
            name: 'SM City CDO-Downtown',
            location: 'Cagayan de Oro, Misamis Oriental',
            kwp: '700.63kWp / 600kW AC Solar PV Power Grid Tied System',
            panels: '1121 panels',
            scope: 'EPC and O&M Services',
            pictures: [smCDOdowntown1,smCDOdowntown2,smCDOdowntown3]
        },
        {
            name: 'SM Consolacion',
            location: 'Consolacion, Cebu',
            kwp: '1.319MWp / 1.1MW AC Solar PV Power Grid Tied System',
            panels: '2111 panels',
            scope: 'EPC and O&M Services',
            pictures: [smConsolacion1,smConsolacion2]
        },
        {
            name: 'SM City General Santos',
            location: 'General Santos, South Cotabato',
            kwp: '1.890MWp / 1.6MW AC Solar PV Power Grid Tied System',
            panels: '3024 panels',
            scope: 'EPC and O&M Services',
            pictures: [smGenSan1,smGenSan2,smGenSan3]
        },
        {
            name: 'SM City Iloilo',
            location: 'Iloilo, Philippines',
            kwp: '1,932 kWp Grid-Tied Solar PV Power System',
            panels: '3,053 PV Modules',
            scope: 'EPC and O&M Services',
            pictures: [smilo1,smilo2,smilo3]
        }, 
        {
            name: 'SM City Novaliches',
            location: 'Quezon City, Philippines',
            kwp: '3116.91 kWp / 2400 kWAC Grid-Tied Solar PV Power System',
            panels: '5,064 PV Modules',
            scope: 'EPC',
            pictures: [smNova1,smNova2,smNova3]
        }, 
        {
            name: 'Metrol Central Mall',
            location: 'Santa Cruz, Laguna',
            kwp: '1.080MWp / 880kWac Grid-Tied Solar PV Power System',
            panels: '1862 PV Modules',
            scope: 'O&M Services',
            pictures: [metroCentral1,metroCentral2,metroCentral3,metroCentral4,metroCentral5]
        }, 
        {
            name: 'Deca Mall',
            location: 'Tondo, Manila, Philippines',
            kwp: '1,113.80 kWp Grid-Tied Solar PV Power System',
            panels: '1,768 PV Modules',
            pictures: [decaTondo1,decaTondo2,decaTondo3]
        }, 
        {
            name: 'GRT / Tsuneishi Shipyard',
            location: 'Pieza, Balamban, Cebu',
            kwp: '120 kWp Grid-Tied Solar PV Power System',
            panels: '352 PV Modules',
            pictures: [grt1,grt2,grt3]
        }, 
        // {
        //     name: 'Mandaue Foam Cainta',
        //     location: 'Cainta, Rizal, Philippines',
        //     kwp: '150 kWp Grid-Tied Solar PV Power System',
        //     panels: '238 PV Modules',
        //     pictures: [mfCainta1,mfCainta2,mfCainta3]
        // },  
        // {
        //     name: 'Mandaue Foam Dasmariñas',
        //     location: 'Dasmariñas, Cavite, Philippines',
        //     kwp: '297.60 kWp / 240 kWAC',
        //     panels: '480 PV Modules',
        //     pictures: [mfDasmarinas1,mfDasmarinas2,mfDasmarinas3,mfDasmarinas4]
        // },  
        // {
        //     name: 'Mandaue Foam Las Piñas',
        //     location: 'Las Piñas, Metro Manila, Philippines',
        //     kwp: '245.70 kWp / 240 kWAC',
        //     panels: '390 PV Modules',
        //     pictures: [mfLasPinas1,mfLasPinas2,mfLasPinas3,mfLasPinas4]
        // }, 
        // {
        //     name: 'Mandaue Foam Muzon',
        //     location: 'Muzon New Building',
        //     kwp: '250 kWp Grid-Tied Solar PV Power System',
        //     panels: '397 PV Modules',
        //     pictures: [mfMuzonNew1,mfMuzonNew2]
        // }, 
        // {
        //     name: 'Mandaue Foam Old Muzon',
        //     location: 'Muzon, Philippines',
        //     kwp: '100 kWp Grid-Tied Solar PV Power System',
        //     panels: '159 PV Modules',
        //     pictures: [mfMuzon1,mfMuzon2]
        // },  
        // {
        //     name: 'Mandaue Foam Sta. Rosa',
        //     location: 'Santa Rosa, Laguna, Philippines',
        //     kwp: '302.40 kWp / 240 kWAC ',
        //     panels: '480 PV Modules',
        //     pictures: [mfStaRosa1,mfStaRosa2,mfStaRosa3,mfStaRosa4]
        // }, 
        // {
        //     name: 'Mandaue Foam Shaw',
        //     location: 'Mandaluyong City, Philippines',
        //     kwp: '150 kWp Grid-Tied Solar PV Power System',
        //     panels: '238 PV Modules',
        //     pictures: [mfShaw1,mfShaw2,mfShaw3,mfShaw4]
        // },   
        {
            name: 'LiteBlock and PWRI',
            location: 'Mandaue City, Cebu',
            kwp: '119.34kW DC and 475.605kW DC Hybrid Solar PV Power Systems',
            panels: '204 & 813 PV Modules',
            pictures: [liteblock1,liteblock2,liteblock3,liteblock4,liteblock5]
        },        
        {
            name: 'JMC Company',
            location: 'Cebu',
            kwp: '100 kwp',
            panels: '182 panels',
            pictures: [project2]
        },
        {
            name: 'Kima Glass Company',
            location: 'Cebu',
            kwp: '100kwp',
            panels: '182 panels',
            pictures: [project3]
        },
        {
            name: 'Afficionado',
            location: 'Manila',
            kwp: '14.3 kwp',
            panels: '27 panels',
            pictures: [aficionado1,aficionado2,aficionado3]
        },
        {
            name: 'Cebu AdConsultants, Inc.',
            location: 'Labangon, Cebu City',
            kwp: '20 kwp',
            panels: '40 panels',
            pictures: [adcons1,adcons2,adcons3]
        }
    ]
    return <>
    {
        projects.map(project =>
            <Card pics={[...project.pictures]} title={project.name} descLoc={project.location} descKwp={project.kwp} panels={project.panels} scope={project.scope}/>
        )
    }
    </>
}

const ResidentialProjects = () => {
    const projects =[
        {
            name: 'Skypod House',
            location: 'Busay Highlands, Cebu City',
            kwp: '15 kwp',
            panels: '42 panels',
            pictures: [skypod1,skypod2,skypod3]
        },
        {
            name: 'Uy Residence',
            location: 'Beverly Hills, Cebu City',
            kwp: '60 kwp',
            panels: '89 panels',
            pictures: [uy1,uy2,uy3]
        },
        {
            name: 'Almera Residence',
            location: 'Maria Luisa Highlands, Cebu City',
            kwp: '5 kwp',
            panels: '12 panels',
            pictures: [almera1,almera2,almera3]
        }, 
        {
            name: 'Manlangit Residence',
            location: 'City of Naga, Cebu',
            kwp: '5 kwp',
            panels: '12 panels',
            pictures: [manlangit1,manlangit2,manlangit3]
        },
        {
            name: 'Sy Residence',
            location: 'Previya Hills, Talamban, Cebu City',
            kwp: '10 kwp',
            panels: '28 panels',
            pictures: [sy1,sy2,sy3]
        },
        {
            name: 'Tagaytay Residence',
            location: 'Tagaytay City',
            kwp: '32.45 kwp',
            panels: '59 panels',
            pictures: [tagaytay1]
        }
    ]
    return <>
    {
        projects.map(project =>
            <Card pics={[...project.pictures]} title={project.name} descLoc={project.location} descKwp={project.kwp} panels={project.panels}/>
        )
    }
    </>
}

const Card = ({title, descLoc, descKwp, pics, panels,scope}) => {
    const [open, setOpen] = useState(false)
    const [selectedPic, setSelectedPic] = useState(0)

    const sliderConfig = {
        all: {
            enableAutoplay: false,
            //autoplayInterval: 7000,
            transitionDuration: 200,
            slidesToShow: 3,
        },
    }
    return <div className='col-span-1'>
        <div className="flex w-full h-full flex-col justify-start bg-[#f7f7f7] rounded-xl shadow-lg shadow-slate-200/60 hover:shadow-[#4CB117] hover:-mt-3 translate duration-[250ms] font-[Montserrat] ">
            
            <img alt="'total solar', 'total solar ph', 'total solar philippines', 'solar panel installer', 'solar panel provider', 'solar panel philippines'" className="aspect-video w-full rounded-t-xl object-cover object-center" src={pics[0]} />
            
            <div className="p-4 grow grid grid-cols-1 content-between">
                <div>
                <h1 className="text-left text-xl font-bold text-[#4CB117] pb-2 whitespace-nowrap">{title}</h1>
                <p className="text-left text-m tracking-tight font-light text-[#1E1C1C] leading-6">{descLoc}</p>
                <p className="text-left text-m tracking-tight font-light text-[#1E1C1C] leading-6">{descKwp}</p>
                </div>
                <div className="mt-3 rounded-xl text-[#1E1C1C] text-right w-full hover:text-[#4CB117] text-sm font-bold cursor-pointer" onClick={()=>setOpen(true)}>View Details <FontAwesomeIcon icon={faChevronRight} className='h-3 w-3'/></div>
            </div>
        </div>
        <CommonModal show={open} onClose={()=>setOpen(false)}>

            
            <div className='flex flex-col md:flex-row space-y-1 sm:space-y-3 sm:space-x-1 h-[75vh]'>
                <div className='shrink-0 w-full md:w-[75%]'>
                    {
                        pics.map((pic, index) => 
                            <CommonTransition key={'selected'+index} open={(selectedPic === index)} durationEnter={'duration-[500ms]'} durationExit={'duration-[0ms]'} exitFrom={'opacity-0'}>
                                <img alt="'total solar', 'total solar ph', 'total solar philippines', 'solar panel installer', 'solar panel provider', 'solar panel philippines', 'solar panel in philippines" className="aspect-video w-full rounded-xl object-cover object-center" src={pic} />
                            </CommonTransition>
                        )
                        
                    }
                    
                    <div className='flex flex-row items-center w-full text-center space-x-1 h-auto mt-5'>
                        <Slider config={sliderConfig} disableNavBtn disablePagination>
                            {
                                pics.map((pic, index) => 
                                    <img
                                        key={'pic'+index}
                                        onClick={()=>setSelectedPic(index)}
                                        alt="'total solar', 'total solar ph', 'total solar philippines', 'solar panel installer', 'solar panel provider', 'solar panel philippines'" className="!w-[50px] rounded-lg object-cover object-center cursor-pointer" 
                                        src={pic} />
                                )
                            }
                        </Slider>
                    </div>
                </div>
                
                <div className='md:pl-8 overflow-y-scroll font-[Montserrat]'>
                    <h1 className="text-left text-xl sm:text-3xl font-bold text-[#4CB117] sm:pb-2 mb-3 sm:mb-6">{title}</h1>
                    <p className="text-left text-base sm:text-1xl tracking-tight font-bold text-[#1E1C1C] leading-6 mb-2 sm:mb-2 flex items-start"><FontAwesomeIcon icon={faMapLocationDot} className='h-7 w-7 mr-4 text-[#2ba837]'/>{descLoc}</p>
                    <p className="text-left text-base sm:text-1xl tracking-tight font-bold text-[#1E1C1C] leading-6 mb-2 sm:mb-2 flex items-center"><FontAwesomeIcon icon={faBoltLightning} className='h-7 w-7 mr-4 text-[#2ba837]'/>{descKwp}</p>
                    <p className="text-left text-base sm:text-1xl tracking-tight font-bold text-[#1E1C1C] leading-6 sm:mb-2 flex items-center"><FontAwesomeIcon icon={faSolarPanel} className='h-7 w-7 mr-4 text-[#2ba837]' />{panels}</p>
                    {
                        scope &&
                        <p className="text-left text-base sm:text-1xl tracking-tight font-bold text-[#1E1C1C] leading-6 sm:mb-2 flex items-center"><FontAwesomeIcon icon={faHelmetSafety} className='h-7 w-7 mr-4 text-[#2ba837]' />{scope}</p>
                    }
                    
                    
                    
                </div>
                

            </div>
            
            
        </CommonModal>
    </div>
}

